/**
 * @fileoverview Polls the student's tracker while the backend is still
 * preparing their assessment structure (copy of the teacher's hook — the
 * modules are kept independent on purpose, see docs/ar-898 plan).
 */

import { useEffect, useRef } from 'react'

const POLL_INTERVAL_MS = 4000
const POLL_MAX_ATTEMPTS = 15 // ~1 min ceiling

export function useProcessingPoll(processing: boolean, onPoll: () => void): void {
  const onPollRef = useRef(onPoll)
  onPollRef.current = onPoll

  useEffect(() => {
    if (!processing) return

    let attempts = 0
    const timer = setInterval(() => {
      attempts += 1
      if (attempts > POLL_MAX_ATTEMPTS) {
        clearInterval(timer)
        return
      }
      onPollRef.current()
    }, POLL_INTERVAL_MS)

    return () => clearInterval(timer)
  }, [processing])
}
